import { ref, watch, toValue } from 'vue';
import { fetchWrapper } from "../_helpers/fetch-wrapper"

const baseUrl = `${import.meta.env.VITE_API_URL}/journal/lock`;

export function useRecordLock(record_type, record) {

    let lockId = null;
    const pendingLock = ref(false);

    const add = () => {
        const record_id = record_type == "draft" ? toValue(record).uuid : toValue(record).remote_id;
        if(record_id  && !pendingLock.value) {
            pendingLock.value = true;
            fetchWrapper.put(`${baseUrl}/${record_type}/${record_id}`).then((value) => {
                lockId = value.lockId;
                pendingLock.value = false;
            });
        }
    };

    watch(record, (newVal) => {
        add();
    });

    const remove = () => {
        if(pendingLock.value) {
            watch(pendingLock, (newVal) => {
                return remove();
            });
        } else {
            return fetchWrapper.delete(`${baseUrl}/byid/${lockId}`);
        }
    }

    const removeAll = () => {
        if(pendingLock.value) {
            watch(pendingLock, (newVal) => {
                return removeAll();
            });
        } else {
            return fetchWrapper.delete(`${baseUrl}/byuser`);
        }
    }

    const list = (record_type, list_ids) => {
        return fetchWrapper.post(`${baseUrl}/${record_type}`, list_ids);
    }
    
    return { add, remove, list, removeAll };
};